// The Columns block's layout, read the same way by both templates and
// by its editor. No imports, so the harness can run it in node.

// The preset row in the editor. A preset sets how many columns there
// are and their shares; it never touches what is in them.
export const COLUMN_PRESETS = [
    { label: '50 / 50', ratios: [1, 1] },
    { label: '33 / 67', ratios: [1, 2] },
    { label: '67 / 33', ratios: [2, 1] },
    { label: '33 / 33 / 33', ratios: [1, 1, 1] },
    { label: '25 / 50 / 25', ratios: [1, 2, 1] },
    { label: '25 × 4', ratios: [1, 1, 1, 1] },
];

export const MAX_COLUMNS = 4;

function ratioOf(col) {
    return Math.min(6, Math.max(1, Math.round(Number(col?.ratio) || 1)));
}

// Which preset the columns currently match, or null for a hand-set mix.
export function activePreset(columns) {
    const ratios = (Array.isArray(columns) ? columns : []).map(ratioOf);
    const hit = COLUMN_PRESETS.find((p) => p.ratios.length === ratios.length && p.ratios.every((r, i) => r === ratios[i]));
    return hit ? hit.label : null;
}

// Apply a preset. Fewer columns than before moves the blocks of every
// column that goes into the last one that stays, so picking a layout
// can never throw away somebody's content.
export function applyPreset(columns, ratios) {
    const cols = Array.isArray(columns) ? columns : [];
    const next = ratios.map((ratio, i) => ({ ...(cols[i] || { blocks: [] }), ratio, blocks: [...((cols[i] && cols[i].blocks) || [])] }));
    if (cols.length > ratios.length) {
        const spill = cols.slice(ratios.length).flatMap((c) => (c && c.blocks) || []);
        next[next.length - 1].blocks.push(...spill);
    }
    return next;
}

export function columnLayout(config) {
    const cols = Array.isArray(config?.columns) ? config.columns : [];
    const gap = Math.max(0, Math.min(120, Number(config?.gap ?? 40)));
    return {
        columns: cols.map((c) => ({ grow: ratioOf(c), blocks: Array.isArray(c?.blocks) ? c.blocks : [] })),
        // The setting is the gap on a wide screen; a phone gets less,
        // never more.
        gapCss: `clamp(${Math.min(20, gap)}px, 3vw, ${gap}px)`,
        align: ({ top: 'flex-start', center: 'center', bottom: 'flex-end' })[config?.vertical_align] || 'flex-start',
        stackAt: ['never', 'tablet', 'mobile'].includes(config?.stack_at) ? config.stack_at : 'mobile',
    };
}
